/** 平台环境常量 */
const PLATFORM = {
  h5: 'h5',
  hippy: 'hippy',
};

export { PLATFORM };



// WEBPACK FOOTER //
// ../src/plugin/report_data_plugin/constants/index.js